import React from 'react';
import './EmptyTodos.css';

function EmptyTodos() {
  return (
    <div className="EmptyTodos">
      <p>No hay tareas todavía. ¡Agrega tu primera tarea!</p>
    </div>
  );
}

export { EmptyTodos };
